export default "__VITE_ASSET__bBePVoUt__"